import React from 'react';
import { Alarm } from '@mui/icons-material';
import { Dialog, DialogContent, DialogContentText } from '@mui/material';

function LogoutDialog() {
  return (
    <Dialog open onClose={() => null}>
      <div
        style={{
          color: 'red',
          paddingTop: 32,
          paddingBottom: 16,
          textAlign: 'center',
        }}
      >
        <Alarm style={{ fontSize: '3rem' }} />
      </div>
      <DialogContent>
        <DialogContentText>
          Sessão expirada. Você será redirecionado para a tela de login.
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

export default LogoutDialog;
